/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationVisitsGetVisitResponse { 
    id?: string;
    salesRepresentativeId?: string | null;
    contactId?: string | null;
    contactName?: string | null;
    isCustomer?: boolean;
    salesRepresentativeName?: string | null;
    userId?: string;
    beginDateTime?: string;
    endDateTime?: string;
    subject?: string | null;
    note?: string | null;
}

